module.exports = __webpack_public_path__ + "img/logo-case.04082f80.png";